/**
 * @module app.shared
 */

import { IApiQueryFilter } from './api-filters';
import { encodeFieldName, encodeBooleanLiteral, mapQueryComparisonOperator } from './api-utilities';

export interface IQueryBooleanFilterOptions {
    ignoreNullValue: boolean;
    negate: boolean;
}

export class ApiQueryBooleanFilter implements IApiQueryFilter {

    constructor(public field: string, public value: boolean | null, public options: IQueryBooleanFilterOptions) {}

    public toString(): string {
        const actualValue = this.options.negate ? !this.value : this.value;
        const encodedField = encodeFieldName(this.field);
        if(actualValue === true) {
            // shorthand for checking true boolean values
            return encodedField;
        }
        else if(actualValue === false) {
            // shorthand for checking false boolean values
            return `not(${encodedField})`;
        }
        // use equals operator for all other cases (really just null)
        const operation = mapQueryComparisonOperator('eq');
        const encodedValue = encodeBooleanLiteral(actualValue);
        return operation.buildExpression(encodedField, encodedValue);
    }

}
